import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import React from 'react';
import { CalculatedDose } from '../../reducers/dosagesPage/dosages.page.state';
import { DiseaseInfo } from '../../types/Diagnose.type';
import {
  DoseAlternative,
  DrugSubstanceInfo,
} from '../../types/DrugDosages.type';
import { DosageContainer } from '../dosages/DosageContainer';

export const CalculatorDialog = ({
  open,
  handleClose,
  doseAlternative,
  animalTypeName,
  treatmentName,
  drugSubstanceId,
  diseaseInfo,
  calculatorState,
  handleCalculatedDose,
  reload,
  setReload,
  mobile,
  handleRWDtrigger,
  drugSubstanceInfo,
}: {
  open: boolean;
  handleClose: () => void;
  doseAlternative: DoseAlternative;
  animalTypeName: string;
  treatmentName: string;
  drugSubstanceId: number;
  diseaseInfo?: DiseaseInfo;
  calculatorState: {
    chosenDoseAlternative: DoseAlternative | null;
    currentCalculatedDoses: CalculatedDose[];
  };
  handleCalculatedDose: (calculatedDose: CalculatedDose, index: number) => void;
  reload: boolean;
  setReload: (boolean: boolean) => void;
  mobile: boolean;
  handleRWDtrigger: (value: any) => void;
  drugSubstanceInfo: DrugSubstanceInfo;
}) => {
  const getIndication = (doseAlternative: DoseAlternative) => {
    const selectedDose = drugSubstanceInfo.DrugSubstance_Doses.find((alt) => {
      return alt.Id === doseAlternative.DrugSubstanceDoseId;
    });
    return selectedDose?.DrugIndication.Name;
  };

  // Check if any phase has non-weight-specific dosage
  const hasNonWeightSpecificDosage =
    doseAlternative?.DrugSubstanceDose_Phases.some(
      (phase) => phase.DrugUnit.CalculationTypeId === 2
    );

  const dialogTitle = hasNonWeightSpecificDosage
    ? 'Dosage Information'
    : 'Calculator';

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description"
      fullWidth={true}
      maxWidth={'lg'}
    >
      <DialogTitle id="scroll-dialog-title">{dialogTitle}</DialogTitle>
      <DialogContent>
        {doseAlternative?.DrugSubstanceDose_Phases.map((dosePhase, index) => {
          return (
            <DosageContainer
              key={dosePhase.Id}
              animalTypeName={animalTypeName}
              treatmentName={treatmentName}
              drugSubstanceId={drugSubstanceId}
              dosePhase={dosePhase}
              calculatedDose={calculatorState.currentCalculatedDoses[index]}
              index={index}
              setCalculatedDose={handleCalculatedDose}
              reload={reload}
              resetReload={() => {
                if (reload) setReload(false);
              }}
              mobile={mobile}
              showDoseInstruction={false}
              handleRWDtrigger={handleRWDtrigger}
              indication={getIndication(doseAlternative)}
            />
          );
        })}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
